/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardArrowUp: {
  name: 'keyboard-arrow-up';
  data: string;
} = {
  name: 'keyboard-arrow-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"/></svg>`
};
